// @ts-nocheck
(function () {
  const TIMEZONE = 'Europe/Copenhagen';

  // Offset in ms between the browser clock (Date.now()) and the true UTC time
  // reported by the server. Positive means the browser is behind the server.
  let clockOffsetMs = 0;

  function readServerOffset() {
    const el = document.querySelector('[data-timed-server-now]');
    if (!el) return;
    const raw = el.getAttribute('data-timed-server-now');
    const serverUnixSeconds = raw ? parseInt(raw, 10) : NaN;
    if (isNaN(serverUnixSeconds)) return;
    clockOffsetMs = serverUnixSeconds * 1000 - Date.now();
  }

  async function refreshServerOffset() {
    try {
      const response = await fetch('/cart.js', { method: 'HEAD', cache: 'no-store' });
      const dateHeader = response.headers.get('date');
      if (!dateHeader) return false;
      const serverMs = Date.parse(dateHeader);
      if (isNaN(serverMs)) return false;
      clockOffsetMs = serverMs - Date.now();
      return true;
    } catch (_err) {
      return false;
    }
  }

  function localNow() {
    const trueInstant = new Date(Date.now() + clockOffsetMs);
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(trueInstant);
    const get = (type) => {
      const part = parts.find((p) => p.type === type);
      return part ? parseInt(part.value, 10) : 0;
    };
    const hour = get('hour');
    return new Date(get('year'), get('month') - 1, get('day'), hour === 24 ? 0 : hour, get('minute'), get('second'));
  }

  function buildDate(el, prefix) {
    const y = parseInt(el.dataset[prefix + 'Year']);
    const mo = parseInt(el.dataset[prefix + 'Month']) - 1;
    const d = parseInt(el.dataset[prefix + 'Day']);
    const h = parseInt(el.dataset[prefix + 'Hour']);
    const m = parseInt(el.dataset[prefix + 'Minute']);
    return new Date(y, mo, d, h, m);
  }

  function checkDateRange(el) {
    const local = localNow();
    const hasStart = el.dataset.timedHasStart === 'true';
    const hasEnd = el.dataset.timedHasEnd === 'true';
    const fromMatch = !hasStart || local >= buildDate(el, 'timedStart');
    const untilMatch = !hasEnd || local < buildDate(el, 'timedEnd');
    return fromMatch && untilMatch;
  }

  function checkRecurring(el) {
    const showDays = el.dataset.timedDays;
    const from = el.dataset.timedFrom;
    const until = el.dataset.timedUntil;
    const local = localNow();

    const day = local.getDay() === 0 ? 7 : local.getDay();
    const hhmm =
      String(local.getHours()).padStart(2, '0') + ':' + String(local.getMinutes()).padStart(2, '0');

    let dayMatch = true;
    if (showDays === 'weekdays') dayMatch = day >= 1 && day <= 5;
    else if (showDays === 'weekends') dayMatch = day === 6 || day === 7;

    const fromMatch = !from || hhmm >= from;
    const untilMatch = !until || hhmm < until;

    return dayMatch && fromMatch && untilMatch;
  }

  function isVisible(el) {
    const enabled = el.dataset.timedEnabled === 'true';
    if (!enabled) return true;

    const mode = el.dataset.timedMode;
    return mode === 'recurring' ? checkRecurring(el) : checkDateRange(el);
  }

  function applyAll() {
    document.querySelectorAll('[data-timed-enabled]').forEach((el) => {
      if (el instanceof HTMLElement) {
        el.style.display = isVisible(el) ? '' : 'none';
      }
    });
  }

  async function init() {
    readServerOffset();
    applyAll();
    const refreshed = await refreshServerOffset();
    if (refreshed) applyAll();
    setInterval(applyAll, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
